import { createContext, useState } from "react"
import toast from "react-hot-toast"
import { temporaryDataPopup } from "../schemas/base/dashboard"
import apiTest from "../services/apiTest"

export const AuthContext = createContext()

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [token, setToken] = useState(null)
  const [error, setError] = useState(null)
  const [theme, setTheme] = useState("light")
  const [popupOpen, setPopupOpen] = useState(false)
  const [dataPopup, setDataPopup] = useState(temporaryDataPopup)

  const verify = async () => {
    try {
      const AuthToken = localStorage.getItem("token")

      if (!AuthToken || AuthToken === "") {
        return false
      }

      apiTest.defaults.headers.common["Authorization"] = AuthToken

      const result = await apiTest.get("/verify")

      if (result?.status !== 200 || result?.data?.error) {
        setError(result?.data?.error)
        toast.error("Falha ao fazer login.")
        return false
      }

      const response = result?.data

      const userNow = {
        userId: response?.user?.userId,
        firstname: response?.user?.firstname,
        lastname: response?.user?.lastname,
        access: response?.user?.access,
        photo: response?.user?.photo,
        email: response?.user?.email,
        invoiceAccount: response?.user?.invoiceAccount,
        startDate: response?.user?.startDate,
        endDate: response?.user?.endDate,
        username: response?.user?.username,
        canceledDate: response?.user?.canceledDate,
        accountType: response?.user?.accountType,
        ddi: response?.user?.ddi ?? "",
        phone: response?.user?.phone ?? ""
      }

      setUser(userNow)
      setToken(AuthToken)
      return true
    } catch (error) {
      console.error(error)
      setUser(null)
      setToken(null)
      setError("Falha de requisição")
      return false
    }
  }

  const login = (email, password) => {
    apiTest
      .post("/auth", { email, password })
      .then(res => {
        if (res.data.token) {
          setToken(res.token)
          apiTest.defaults.headers.common["Authorization"] = res.data.token
          localStorage.setItem("token", res.data.token)

          setUser({
            userId: res.data.userId,
            firstname: res.data.firstname,
            lastname: res.data.lastname,
            access: res.data.access,
            photo: res.data.photo,
            email: res.data.email
          })

          return true
        } else {
          setUser(null)
          setToken(null)
          setError(res.data.message)
          return false
        }
      })
      .catch(errorS => {
        setUser(null)
        setToken(null)
        if (
          errorS.response &&
          errorS.response.data &&
          errorS.response.data.message
        ) {
          setError(errorS.response.data.message)
        } else {
          setError("Falha de requisição")
        }

        return false
      })
  }

  const logout = () => {
    localStorage.removeItem("token")
    setUser(null)
    setToken(null)
    toast.dismiss()
  }

  const contextValue = {
    verify,
    user,
    token,
    popupOpen,
    login,
    logout,
    theme,
    error,
    dataPopup,
    setError,
    setTheme,
    setToken,
    setUser,
    setPopupOpen,
    setDataPopup
  }

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  )
}
